import * as angular from 'angular';
import {IController} from "angular";
import * as _ from "lodash";
import {ServicesViewsStateType} from "../../types/services-views-state.type";

export class DeliveriesTableCtrl implements IController {
  infiniteScroll: any;
  selectedIds: any;
  isScrollable: any;
  dynamicColumns: any;
  packageDynamicColumns: any;
  sortType: any;
  columns: any;
  onSortTypeChange: Function;
  selectedIdsChanged: Function;
  onEditAddress: Function;
  onFilterByType: Function;

  private selectedKeys: any;
  private expandedKeys: any;
  private asceDescIconsMap: any;
  private hasFleetManagementPermission: any;
  private hasPricePlanPermission: any;
  private displayAsItems: any;

  public isSortLocationPickup: boolean = false;

  /* @ngInject */
  constructor(private $mdMedia, private commonsConstants, private deliveriesConstants, private IAMPermissions) {
    this.hasFleetManagementPermission = this.IAMPermissions.hasPermission('fleetManagement.vehicles.list');
    this.hasPricePlanPermission = this.IAMPermissions.hasPermission('priceplan.list');
  }

  $onInit() {
    this.selectedKeys = {};
    this.expandedKeys = {};
    this.asceDescIconsMap = this.commonsConstants.sortIconsMap;

    if (!this.columns) {
      this.columns = this.commonsConstants.viewsTableColumns[ServicesViewsStateType.DELIVERIES_TABLE_STATE];
    }

    this.selectedKeys = {};
    _.forEach(this.selectedIds, (selectedId) => {
      this.selectedKeys[selectedId] = true;
    });

  }

  $onChanges(changes) {
    if (changes.selectedIds && !changes.selectedIds.isFirstChange()) {
      this.$onInit();
    }
    if (changes.columns && !changes.columns.isFirstChange()) {
      this._setColumns(this.columns);
    }
  };

  $doCheck() {
    this.displayAsItems = !this.$mdMedia('gt-xs');
  };

  setEvents() {
    const div1 = document.getElementById('header');
    const div2 = document.querySelectorAll('.md-virtual-repeat-scroller')[0];

    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    }, {passive: true})
  }


  toggleDelivery(deliveryId) {
    this.selectedKeys[deliveryId] = !this.selectedKeys[deliveryId];
    const selectedIds = _.map(this.selectedKeys, (value, key) => {
      if (value) return key;
    });
    this.selectedIdsChanged({selectedIds: _.compact(selectedIds)});
  }

  onExpand(serviceId) {
    this.expandedKeys[serviceId] = !this.expandedKeys[serviceId];
  }

  onSortLocation() {
    this.onSortTypeChange({name: 'sortAgentName'})
  }

  // ******************************
  //        Private methods
  // ******************************

  private _setColumns(columns) {
    this.columns = columns || this.commonsConstants.viewsTableColumns[ServicesViewsStateType.DELIVERIES_TABLE_STATE];
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveriesTable', {
    bindings: {
      infiniteScroll: '<',
      selectedIds: '<',
      isScrollable: '<?',
      dynamicColumns: '<?',
      packageDynamicColumns: '<?',
      sortType: '<',
      columns: '<?',
      onSortTypeChange: '&',
      selectedIdsChanged: '&',
      onEditAddress: '&',
      onFilterByType: '&'
    },
    template: require('./deliveries-table.html').default,
    // /* @ngInject */
    // templateUrl: function(templates) {
    //   return templates.getTemplateUrl({
    //     base: 'app/modules/deliveries/components/deliveries-table/deliveries-table.html',
    //     lite : 'app/modules/deliveries/components/deliveries-table/deliveries-table.lite.html'
    //   });
    // },
    controller: DeliveriesTableCtrl
  });
